export default "__VITE_ASSET__BSZEnPCg__"